import React, { useState, useEffect, useRef } from 'react';
import { Users } from 'lucide-react';
import API_URL from '../config/ApiUrl';
import { useTheme } from '../arrangement/ThemeContext';

export const CommunityStatsCard = () => {
  const { colors } = useTheme();
  
  const [stats, setStats] = useState({
    onlineMembers: 1247,
    threadsToday: 34,
    newMembers: 23,
    totalInteractionsWeek: 1580
  });

  const [loading, setLoading] = useState(false);
  const intervalRef = useRef(null);

  const fetchStats = async () => {
    try {
      const response = await fetch(`${API_URL}/api/community/stats`);
      const data = await response.json();
      
      if (data.success) {
        setStats({
          onlineMembers: data.stats.onlineMembers,
          threadsToday: data.stats.threadsThisWeek,
          newMembers: data.stats.newMembersWeek,
          totalInteractionsWeek: data.stats.totalInteractionsWeek
        });
      }
    } catch (err) {
      console.error('Error fetching community stats:', err);
    }
  };

  useEffect(() => {
    fetchStats();

    const interval = setInterval(() => {
      fetchStats();
      
      setStats(prev => ({
        ...prev,
        onlineMembers: prev.onlineMembers + Math.floor(Math.random() * 3) - 1,
        threadsToday: prev.threadsToday + Math.floor(Math.random() * 2)
      }));
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{
      background: colors.comeCard,        // was '#1a1a1a'
      borderRadius: '16px',
      padding: '20px',
      border: `1px solid ${colors.border}`  // was '#333'
    }}>
      <h3 style={{
        margin: '0 0 16px 0',
        fontWeight: '600',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        color: colors.textPrimary             // was '#e5e5e5'
      }}>
        <Users size={18} style={{ color: '#3b82f6' }} />
        Community Stats
      </h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '8px 0'
        }}>
          <span style={{ fontSize: '14px', color: colors.textSecondary, display: 'flex', alignItems: 'center', gap: '6px' }}>
            🟢 Members online
          </span>
          <span style={{
            fontWeight: '600',
            color: colors.accentPrimary1,       // was '#00d4aa'
            fontSize: '14px',
            animation: stats.onlineMembers !== 1247 ? 'pulse 0.5s ease' : 'none'
          }}>
            {stats.onlineMembers.toLocaleString()}
          </span>
        </div>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '8px 0'
        }}>
          <span style={{ fontSize: '14px', color: colors.textSecondary }}>💬 Posts This Week</span>
          <span style={{ fontWeight: '600', color: colors.textPrimary, fontSize: '14px' }}>
            {stats.threadsToday}
          </span>
        </div>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '8px 0'
        }}>
          <span style={{ fontSize: '14px', color: colors.textSecondary }}>👥 Members This Week</span>
          <span style={{ fontWeight: '600', color: colors.textPrimary, fontSize: '14px' }}>
            +{stats.newMembers}
          </span>
        </div>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '8px 0',
          borderTop: `1px solid ${colors.border}`,
          marginTop: '8px',
          paddingTop: '12px'
        }}>
          <span style={{ fontSize: '14px', color: colors.textSecondary }}>⚡ Interactions this week</span>
          <span style={{ fontWeight: '700', color: colors.textPrimary, fontSize: '16px' }}>
            {stats.totalInteractionsWeek.toLocaleString()}          
          </span>
        </div>
      </div>
    </div>
  );
};